<div class="root">
    <h2 mat-dialog-title>URL Documentación</h2>
    <mat-dialog-content>
        <form #form class="example-form">
            <mat-form-field class="example-full-width" appearance="outline">
                <input type="url" name="url" class="url" matInput [formControl]="documentation"
                    [errorStateMatcher]="matcher" maxlength="256"
                    placeholder="https://example.com" pattern="https://.*" size="256"
                   >
<!--                <mat-error *ngIf="documentation.hasError('required')">URL <strong>requerido</strong></mat-error>-->
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button mat-raised-button color="primary" (click)="onSubmit()">Guardar</button>
        <button mat-button color="primary" (click)="onClose()">Cerrar</button>
    </mat-dialog-actions>
</div>
